import { SET_VALIDATOR_USED } from "../constants/validatorConstants";

export const setValidatorUsed = () => {
  return {
    type: SET_VALIDATOR_USED
  };
};
